import { render, staticRenderFns } from "./homeBottom.vue?vue&type=template&id=4434fe6c&scoped=true&"
import script from "./homeBottom.vue?vue&type=script&lang=js&"
export * from "./homeBottom.vue?vue&type=script&lang=js&"
import style0 from "./homeBottom.vue?vue&type=style&index=0&id=4434fe6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4434fe6c",
  null
  
)

export default component.exports